import { render, staticRenderFns } from "./ListadoCopasst.vue?vue&type=template&id=970e281e&"
import script from "./ListadoCopasst.vue?vue&type=script&lang=js&"
export * from "./ListadoCopasst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports